import * as React from 'react';

import { AboutContainer } from 'containers/project-love/about/about-container';

const AboutPage: React.FunctionComponent = () => {
  return <AboutContainer />;
};

export default AboutPage;

export { getServerSideProps } from 'lib/get-server-side-props';
